import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUsers, PlugAndPlayUser } from '../../api/users';

export const getUsersAsync = createAsyncThunk(
  'plugAndPlayUsers/getUsers',
  getUsers
);

interface UsersState {
  data: PlugAndPlayUser[];
  loading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  data: [],
  loading: false,
  error: null
};

const usersSlice = createSlice({
  name: 'plugAndPlayUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsersAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(getUsersAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch users';
      });
  }
});

export default usersSlice;